import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseOverlayPanelComponent } from '@d-components';
import { AuthService } from '@d-services';
import { AuditService } from '@d-services/wms/audit.service';

@Component({
  selector: 'app-header-avatar',
  templateUrl: './header-avatar.component.html',
  styleUrls: ['./header-avatar.component.scss'],
})
export class HeaderAvatarComponent implements OnInit {
  name: string = '';
  email: string = '';
  @ViewChild(BaseOverlayPanelComponent, { static: true })
  child?: BaseOverlayPanelComponent;

  constructor(
    private router: Router,
    private auditService: AuditService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.authService.getCurrentUser().subscribe((currentUser) => {
      this.name = currentUser.name;
      this.email = currentUser.email;
    });
  }

  togglePanel(): void {
    this.child?.togglePanel();
  }

  logout() {
    this.authService.logout();
    window.location.href = '/login';
    // this.router.navigate(['/login']);
    this.auditService.createEventLog('OP', 'logout').add(() => {});
  }
}
